var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHasToilets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.5a3 3 0 110 6 3 3 0 010-6zm4.5 8h-9c0 4.068 1.047 6.441 3 7.5v6.5h3V17c2-1.059 3-3.432 3-7.5zM5 1.5a3 3 0 110 6 3 3 0 010-6zM5 9C1.962 9 .5 13.5.5 18.5h3v5h3v-5h3C9.5 13.5 8.037 9 5 9zm6.5 15V0",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
}
export default SvgHasToilets;